import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/home/runner/work/commerce-pwa-studio/commerce-pwa-studio/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
import UtilityFunctions from '/src/data/auto-generated/pagebuilder/lib/utils.md';
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "utility-functions"
    }}>{`Utility functions`}</h1>
    <p>{`The utility functions help with retrieving commonly stored data in a content type. For example, the `}<inlineCode parentName="p">{`getAdvanced(node)`}</inlineCode>{` wrapper function retrieves all the content type's Advanced form section settings so you do not have to worry about retrieving each one separately. Retrieving background images and associated properties is also made easy with the `}<inlineCode parentName="p">{`getBackgroundImages(node)`}</inlineCode>{` function.`}</p>
    {/*
     The reference doc content is generated automatically from the source code.
     To update this section, update the doc blocks in the source code
     */}

    <UtilityFunctions mdxType="UtilityFunctions" />

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      